<template>
  <div class="flex flex-col items-center max-w-lg mx-auto mt-5 mb-3 border rounded md:my-10 border-sc-gray-light shadow-sc-secondary">
    <div class="w-full px-8 mt-6 text-left md:px-16 md:mt-10">
      <h1
        class="text-xl leading-9 md:text-3xl text-primary"
      >
        {{ $t('message.onboarding.createEntityStep.add') }}
      </h1>
    </div>
    <div class="w-full px-8 mt-4 bg-white md:px-16 md:mt-8">
      <form
        @submit.prevent
      >
        <label
          class="inline-block py-1 text-sm text-secondary"
          for="newEntityName"
        >
          {{ $t('message.onboarding.createEntityStep.name') }}
        </label>
        <input
          v-model="newEntityName"
          class="w-full px-3 py-2 leading-tight border rounded appearance-none shadow-sc-secondary text-primary border-sc-gray-light focus:outline-none focus:shadow-sc-card focus:border-sc-blue"
        >
        <div class="text-red-700 registration-form__alert">
          <p v-if="errors.length">
            <ul>
              <li
                v-for="error in errors"
                :key="error"
              >
                {{ error }}
              </li>
            </ul>
          </p>
        </div>
        <div class="w-full my-4">
          <navigation-buttons
            :is-form-valid="!!newEntityName"
            @next="createNewEntity"
            @back="$emit('back')"
            :show-back="false"
          />
        </div>
      </form>
    </div>
    <div class="flex items-center w-full px-8 mt-8 mb-6 text-xs md:px-16 md:mt-16 md:mb-12 md:mx-auto text-sc-gray">
      <img
        :src="require('@assets/images/info.svg')"
        class="w-6 h-auto opacity-75"
      >
      <div class="w-full pl-4 text-left">
        <p class="leading-5">
          {{ $t('message.onboarding.createEntityStep.info') }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapWritableState } from 'pinia';
import { useOnboardingWizardStore } from '../../stores/onboarding-wizard';
import EntitiesApi from '../../api/entities';
import NavigationButtons from './navigation-buttons.vue';

export default {
  components: { NavigationButtons },
  data() {
    return {
      errors: [],
      newEntityName: null,
    };
  },
  computed: {
    ...mapWritableState(useOnboardingWizardStore, [
      'firstEntityId',
      'fintocAccountConnected',
    ]),
  },
  methods: {
    async createNewEntity() {
      this.errors = [];
      if (this.newEntityName) {
        const response = await EntitiesApi.createEntity(this.newEntityName);
        this.$emit('next');
        this.firstEntityId = response.data.entity.id;
        this.fintocAccountConnected = false;
      } else {
        this.errors.push(this.$t('message.onboarding.createEntityStep.error'));
      }
    },
  },
};
</script>
